






































import Vue from 'vue';
import util from '@/utils';
import { Component } from 'vue-property-decorator';
import { getOrgInfo } from '@/api/school';
import { State } from 'vuex-class';
import { TOrgInfo } from '@/types/views/school';
const namespace = 'user';
@Component({
  components: {
    BoxCard: () => import('./box.vue')
  }
})
export default class CoursePackage extends Vue {
  @State('orgId', { namespace }) orgId!: string;
  private orgInfo: TOrgInfo = {
    surplusCoursePackage: 10, // 防止el-alert先出现后消失bug
    totalCoursePackage: 10
  };
  private activeName = 'consuption';
  private activated() {
    this.getOrgInfo();
  }
  private handleClick(path: any) {
    this.$router.push(`/school/course-package/${path.name}`);
  }
  /**
   * @description: 获取机构信息
   * @param
   * @return:
   */
  private async getOrgInfo() {
    try {
      let res: any = await getOrgInfo({
        orgId: this.orgId
      });
      util.copy(this.orgInfo, res.orgInfo);
    } catch (e) {
      this.$message.error(e);
    }
  }
}
